
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * AmountRoundingPolicy enum
 */
class AmountRoundingPolicy {
  /**
   * Initialize enum with a given value
   * @param {AmountRoundingPolicy|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof AmountRoundingPolicy) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!AmountRoundingPolicy}
   * @param {!AmountRoundingPolicy} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof AmountRoundingPolicy)) {
      throw new TypeError('Instance of AmountRoundingPolicy is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!AmountRoundingPolicy}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!AmountRoundingPolicy}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === AmountRoundingPolicy.ROUND_DOWN.value) {
      return 'ROUND_DOWN'
    }
    if (this.value === AmountRoundingPolicy.ROUND_HALF_UP.value) {
      return 'ROUND_HALF_UP'
    }
    if (this.value === AmountRoundingPolicy.ROUND_UP.value) {
      return 'ROUND_UP'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!AmountRoundingPolicy}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!AmountRoundingPolicy}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!AmountRoundingPolicy} Created enum
   */
  static fromObject (other) {
    return new AmountRoundingPolicy(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
AmountRoundingPolicy.ROUND_DOWN = new AmountRoundingPolicy(0 + 0)
// noinspection PointlessArithmeticExpressionJS
AmountRoundingPolicy.ROUND_HALF_UP = new AmountRoundingPolicy(0 + 1)
// noinspection PointlessArithmeticExpressionJS
AmountRoundingPolicy.ROUND_UP = new AmountRoundingPolicy(0 + 2)

export { AmountRoundingPolicy };

/**
 * Fast Binary Encoding AmountRoundingPolicy field model
 */
class FieldModelAmountRoundingPolicy extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelAmountRoundingPolicy}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelAmountRoundingPolicy}
   * @param {AmountRoundingPolicy=} defaults Default value, defaults is new AmountRoundingPolicy()
   * @returns {!AmountRoundingPolicy} Result value
   */
  get (defaults = new AmountRoundingPolicy()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new AmountRoundingPolicy(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelAmountRoundingPolicy}
   * @param {!AmountRoundingPolicy} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelAmountRoundingPolicy };
